module.exports = __webpack_public_path__ + "img/home_bg.53e4135e.png";